exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_playlists_3rXJNXnWs_ba7YB_tidGaR {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_12zfIwJmhMgjrJqNQF3-3e {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_r9B26NKeORil1MoVbv0h {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_1Zf_-iVWiqD_w5CtiI8Bri {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_playlists": "IA_playlists_3rXJNXnWs_ba7YB_tidGaR",
	"IA_filters": "IA_filters_12zfIwJmhMgjrJqNQF3-3e",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_r9B26NKeORil1MoVbv0h",
	"IA_paginationPageCount": "IA_paginationPageCount_1Zf_-iVWiqD_w5CtiI8Bri"
};